import Container from "../components/Layout/Container.js";
import HabitStudyComponents from "../components/TodayTodoList/HabitStudyComponents.js";

function HabitTrackerPage() {
  return (
    <Container>
      <HabitStudyComponents />
    </Container>
  );
}

export default HabitTrackerPage;
